import gql from 'graphql-tag';

const MUTATION_SIGN_IN = gql`
  mutation signIn($params: SignInInput!) {
    signIn(params: $params) {
      accessToken
      isSuccess
      message 
      me {
        id
        email
        roles
        firstName
        lastName
      }
    }
  }
`;


export default MUTATION_SIGN_IN;
